import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ArticleDetailData } from '../models/article';
import { ArticleService } from '../services/article.service';
import { AppConstants } from '../app_setting/app-constants';
import * as firebase from 'firebase';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import { AlertComponent } from '../alert/alert.component';

@Component({
  selector: 'app-detail-artikel',
  templateUrl: './detail-artikel.component.html',
  styleUrls: ['./detail-artikel.component.css']
})
export class DetailArtikelComponent implements OnInit {

  @HostListener('window:resize', ['$event']) onResize(event){
    const winWidth = event.target.innerWidth;
    if(winWidth <= 991){
      this.isSidebarCollapse = true;
    } else {
      this.isSidebarCollapse = false;
    }
  }

  @ViewChild("alertModal") alertModal: AlertComponent;
  @ViewChild("articleContainer", { read: ElementRef })  public articleContainer: ElementRef<any>;

  artikeldatas: any;
  artikelId: any;
  artikelDetailDatas: ArticleDetailData = new ArticleDetailData();
  imageArticle: string = '';
  relatedArticle: any[] = [];
  isLoadArticle = true;
  isLoadRelated: boolean = true;
  listTags = [];
  screenWidth: any;
  isSidebarCollapse = false;

  constructor(
    private router: ActivatedRoute,
    private route: Router,
    public artikelService: ArticleService,
    private sanitizer: DomSanitizer,
  ) { }

  ngOnInit() {
    this.router.params.subscribe(value => {
      // console.log('whatisvalueinparam', value.id);
      this.artikelId = value.id;
    })
    // console.log('artikelid', this.artikelId);
    // this.artikeldatas = JSON.parse(atob(this.router.snapshot.paramMap.get('id')));
    // console.log('receivedArticle', this.artikeldatas);
    this.getDetail();
    this.detectScreenSize();
  }

  public getDetail(){
    this.artikelService.getArticleDetail(this.artikelId,
      (data)=>{
        this.isLoadArticle = false;
        this.isLoadRelated = false;
        const related: object[] = data.relatedArticles;
        // console.log('detail article received from server \n', data)
        this.artikelDetailDatas = data;
        // console.log(data.descriptionWeb);
        this.relatedArticle = related;
        this.imageArticle = !this.artikelDetailDatas.image ? AppConstants.NoImageDefault : this.artikelDetailDatas.image.image_web;
        this.listTags = this.artikelDetailDatas.tags.split(',');

        // console.log(this.artikelDetailDatas)

    }, (err)=>{
      // console.log('err: ', err);
      this.alertModal.show('Gagal', err.message)
    });
  }

  goToArticle(artikel: any){
    firebase.analytics().logEvent('click_related_article')

    this.route.navigate(['/detail-artikel/', artikel.id]).then(page => {window.location.reload();});
    // this.route.navigate([`/detail-artikel/${btoa(JSON.stringify(artikel))}`]).then(page => {window.location.reload();});
  }

  detectScreenSize(){
    const sw = window.innerWidth;
    if(sw <= 991){
      this.isSidebarCollapse = true;
      // console.log('sidebar should be true', this.isSidebarCollapse);
    } else {
      this.isSidebarCollapse = false;
      // console.log('sidebar should be false', this.isSidebarCollapse);
    }
  }

  whatIs(item: string){
    // console.log('/artikel/tags=?', item);
  }

  relatedToLeft(){
    this.articleContainer.nativeElement.scrollTo({left: (this.articleContainer.nativeElement.scrollLeft - 150), behaviour: 'smooth'});
  }

  relatedToRight(){
    this.articleContainer.nativeElement.scrollTo({left: (this.articleContainer.nativeElement.scrollLeft + 150), behaviour: 'smooth'});
  }

  goTag(s: string){
    // console.log('whattagis?', s);
    this.route.navigate(['/artikel/'], {queryParams: {tags: s}})
  }

  logMe(i: any){
    console.log('you will load this ', i);
  }

  getThumbnail(url: string){
    if (url === null || url === '' || url === undefined){
      return `url(${AppConstants.NoImageDefault})`;
    }

    let sanitized: SafeStyle = this.sanitizer.bypassSecurityTrustStyle(`url(${url})`);

    return sanitized;
  }
}
